const SIZE = 34;
const STROKE = 4;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

/** Anneau de progression compact — taux de recouvrement d'un adhérent (0 à 1),
 * pourcentage affiché au centre. Émeraude à 100 %, ambre en deçà, ardoise à 0 %. */
const RecoveryRing = ({ rate = 0 }) => {
  const pct = Math.round(Math.min(1, Math.max(0, rate)) * 100);
  const color = pct >= 100 ? "#059669" : pct > 0 ? "#d97706" : "#94a3b8";
  const trackColor = pct >= 100 ? "#d1fae5" : pct > 0 ? "#fef3c7" : "#f1f5f9";
  const offset = CIRCUMFERENCE * (1 - pct / 100);

  return (
    <div className="relative inline-flex items-center justify-center flex-shrink-0" style={{ width: SIZE, height: SIZE }}>
      <svg width={SIZE} height={SIZE} className="-rotate-90">
        <circle cx={SIZE / 2} cy={SIZE / 2} r={RADIUS} fill="none" stroke={trackColor} strokeWidth={STROKE} />
        <circle
          cx={SIZE / 2} cy={SIZE / 2} r={RADIUS}
          fill="none"
          stroke={color}
          strokeWidth={STROKE}
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <span className="absolute text-[9px] font-semibold" style={{ color }}>
        {pct}%
      </span>
    </div>
  );
};

export default RecoveryRing;
